import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import Button from 'components/Button/Button';
import TextInput from 'components/TextInput/TextInput';

const styles = theme => ({
  headline: {
    marginBottom: theme.spacing(4),
  },
  instructions: {
    marginBottom: theme.spacing(2),
    opacity: 0.8,
  },
  textField: {
    height: 60,
  },
  button: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
});

function VerificationForm(props) {
  const { classes, verificationCode, onVerificationCodeChanged, verify } = props;
  const { t } = useTranslation('common');

  return (
    <div>
      <Typography variant="h5" className={classes.headline}>
        {t('verification.registration_complete')}
      </Typography>
      <Typography variant="body1" className={classes.instructions}>
        {t('verification.verification_instructions')}
      </Typography>
      <TextInput
        value={verificationCode}
        onChange={onVerificationCodeChanged}
        fullWidth={true}
        label={t('verification.verification_code')}
      />
      <Button
        className={classes.button}
        fullWidth
        onClick={verify}
        variant="contained" color="secondary"
      >
        {t('verification.verify')}
      </Button>
    </div>
  )
}

VerificationForm.propTypes = {
  classes: PropTypes.object.isRequired,
  verificationCode: PropTypes.string.isRequired,
  onVerificationCodeChanged: PropTypes.func.isRequired,
  verify: PropTypes.func.isRequired,
};

export default withStyles(styles)(VerificationForm)